import { render } from "./AdminJournees.vue?vue&type=template&id=520eddf2&scoped=true"
import script from "./AdminJournees.vue?vue&type=script&lang=js"
export * from "./AdminJournees.vue?vue&type=script&lang=js"

import "./AdminJournees.vue?vue&type=style&index=0&id=520eddf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520eddf2"]])

export default __exports__